import React from 'react'
import { UserProfileHelper } from '@lura/shared'
import type { AuthUser } from '@lura/shared'

interface TopNavigationProps {
  currentPage?: string
  onSignOut?: () => void
  user?: AuthUser | null
}

export const TopNavigation: React.FC<TopNavigationProps> = ({
  currentPage = 'Patients',
  onSignOut,
  user
}) => {
  // Build navigation items based on user roles
  const navigationItems = []

  // Add Studies, Patients, and Devices tabs for clinicians
  if (UserProfileHelper.isClinician(user)) {
    navigationItems.push({ label: 'Studies', href: '/studies' })
    navigationItems.push({ label: 'Patients', href: '/patients' })
    navigationItems.push({ label: 'Devices', href: '/clinician/devices' })
  }

  // Add Studies, Clinicians, Devices tabs for Study Admins (NO Users)
  if (UserProfileHelper.isStudyAdmin(user)) {
    navigationItems.push({ label: 'Studies', href: '/studies' })
    navigationItems.push({ label: 'Clinicians', href: '/clinicians' })
    navigationItems.push({ label: 'Devices', href: '/devices' })
  }

  // Add Users and Firmware tabs only for Web Admins
  if (UserProfileHelper.isWebAdmin(user)) {
    navigationItems.push({ label: 'Users', href: '/users' })
    navigationItems.push({ label: 'Firmware', href: '/firmware' })
  }

  const userName = UserProfileHelper.getDisplayName(user)

  return (
    <div className="w-full p-5">
      <nav className="bg-soft-black rounded-full">
        <div className="max-w-7xl mx-auto px-5 lg:pl-2.5 lg:pr-5 py-2.5">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <a href="/" className="flex items-center">
              <img src="/lura-logo.svg" alt="LURA" className="h-16 w-auto" />
            </a>

            {/* Navigation Links */}
            <div className="flex items-center space-x-8">
              {navigationItems.map(item => (
                <a
                  key={item.label}
                  href={item.href}
                  className={`relative text-sm font-medium tracking-wide transition-colors ${
                    currentPage === item.label
                      ? 'text-white'
                      : 'text-white/80 hover:text-white'
                  }`}
                >
                  {item.label}
                  {currentPage === item.label && (
                    <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-highlight-pink"></div>
                  )}
                </a>
              ))}
            </div>

            {/* User Info and Actions */}
            <div className="flex items-center space-x-6">
              {user?.profile && (
                <span className="text-white/80 text-sm">
                  Welcome, {userName}
                </span>
              )}
              <div className="flex items-center space-x-3">
                {onSignOut && (
                  <button
                    onClick={onSignOut}
                    className="text-white/80 hover:text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
                  >
                    Sign out
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default TopNavigation
